import { Injectable } from '@angular/core';
import { REGISTER } from "app/model/register.model";

@Injectable()
export class BUSINESSREFService {
    constructor() { }


    generateBusinessRef(pdfOBJ: REGISTER) {

        return {
            style: 'tableExample',
            table: {
                widths: ['50%', '25%', '25%'],
                body:
                [
                    [
                        {text:'1. Supplier Name:',style: "questions"},
                        { colSpan: 2, text: '1. Phone:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + pdfOBJ.businessRefArray[0].in_supplier1_name, italics: true },
                        { colSpan: 2, text: pdfOBJ.businessRefArray[0].in_supplier1_phonecode+' ' + pdfOBJ.businessRefArray[0].in_supplier1_phone, italics: true }
                        , ''
                    ],
                    [
                        {text:'1. Contact Name:',style: "questions"},
                        { colSpan: 2, text: '1. Email:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + pdfOBJ.businessRefArray[0].in_supplier1_contact, italics: true },
                        { colSpan: 2, text: ' ' + pdfOBJ.businessRefArray[0].in_supplier1_email, italics: true }
                        , ''
                    ],
                    //一共四组 还有三组
                    [
                        {text:'2. Supplier Name:',style: "questions"},
                        { colSpan: 2, text: '2. Phone:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + ( pdfOBJ.businessRefArray.length<2?"": pdfOBJ.businessRefArray[1].in_supplier1_name), italics: true },
                        { colSpan: 2, text: ' ' +( pdfOBJ.businessRefArray.length<2?"":  pdfOBJ.businessRefArray[1].in_supplier1_phonecode+' ' +pdfOBJ.businessRefArray[1].in_supplier1_phone), italics: true }
                        , ''
                    ],
                    [
                        {text:'2. Contact Name:',style: "questions"},
                        { colSpan: 2, text: '2. Email:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + ( pdfOBJ.businessRefArray.length<2?"": pdfOBJ.businessRefArray[1].in_supplier1_contact), italics: true },
                        { colSpan: 2, text: ' ' + ( pdfOBJ.businessRefArray.length<2?"": pdfOBJ.businessRefArray[1].in_supplier1_email), italics: true }
                        , ''
                    ],
                    //一共四组还有两组
                    [
                        {text:'3. Supplier Name:',style: "questions"},
                        { colSpan: 2, text: '3. Phone:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + ( pdfOBJ.businessRefArray.length<3?"": pdfOBJ.businessRefArray[2].in_supplier1_name), italics: true },
                        { colSpan: 2, text: ' ' + ( pdfOBJ.businessRefArray.length<3?"": pdfOBJ.businessRefArray[2].in_supplier1_phonecode+' ' +pdfOBJ.businessRefArray[2].in_supplier1_phone), italics: true }
                        , ''
                    ],
                    [
                        {text:'3. Contact Name:',style: "questions"},
                        { colSpan: 2, text: '3. Email:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + ( pdfOBJ.businessRefArray.length<3?"": pdfOBJ.businessRefArray[2].in_supplier1_contact), italics: true },
                        { colSpan: 2, text: ' ' + ( pdfOBJ.businessRefArray.length<3?"": pdfOBJ.businessRefArray[2].in_supplier1_email), italics: true }
                        , ''
                    ],
                    //一共四组 还有一组
                    [
                        {text:'4. Supplier Name:',style: "questions"},
                        { colSpan: 2, text: '4. Phone:' ,style: "questions"}, '']

                    ,
                    [
                        { text: ' ' + ( pdfOBJ.businessRefArray.length<4?"": pdfOBJ.businessRefArray[3].in_supplier1_name), italics: true },
                        { colSpan: 2, text: ' ' +( pdfOBJ.businessRefArray.length<4?"":  pdfOBJ.businessRefArray[3].in_supplier1_phonecode+' ' +pdfOBJ.businessRefArray[3].in_supplier1_phone), italics: true }
                        , ''
                    ],
                    [
                        {text:'4. Contact Name:',style: "questions"},
                        { colSpan: 2, text: '4. Email:',style: "questions" }, '']

                    ,
                    [
                        { text: ' ' + ( pdfOBJ.businessRefArray.length<4?"": pdfOBJ.businessRefArray[3].in_supplier1_contact), italics: true },
                        { colSpan: 2, text: ' ' + ( pdfOBJ.businessRefArray.length<4?"": pdfOBJ.businessRefArray[3].in_supplier1_email), italics: true }
                        , ''
                    ]
                ]
            }
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/services/pdf/businessref.generation.ts